var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-snackbar",
    {
      staticStyle: { "z-index": "9999!important" },
      attrs: { timeout: _vm.timeout, color: _vm.color, centered: "" },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function ({ attrs }) {
            return [
              _c(
                "v-btn",
                _vm._b(
                  {
                    attrs: { small: "", icon: "", fab: "" },
                    on: {
                      click: function ($event) {
                        _vm.showing = false
                      },
                    },
                  },
                  "v-btn",
                  attrs,
                  false
                ),
                [_c("i", { staticClass: "las la-times la-2x" })]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showing,
        callback: function ($$v) {
          _vm.showing = $$v
        },
        expression: "showing",
      },
    },
    [_vm._v("\n    " + _vm._s(_vm.message) + "\n    ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }